"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./DevelopmentSupportServicesCardSection.module.css";
import data from "../../data/development-support";
import ServiceCard from "../../components/ServiceCard";

export default function DevelopmentSupportServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;
  const displayData = services?.items || data;

  return (
    <section className={`py-5 ${styles.section}`}>
      <div className="container">
        <div
          className={`text-center mb-5 ${styles.heading}`}
          data-reveal="fade"
        >
          <span className={styles.eyebrow}>{services?.title || "Services"}</span>
          <h2 className={styles.title}>{services?.subtitle || "Development Support Services"}</h2>
        </div>
        <div className="row g-4" data-reveal="stagger-mix">
          {displayData.map((service, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <ServiceCard {...service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
